<ng-container [formGroup]="form">
  <input
    type="search"
    id="search-field"
    [class.autocomplete-is-open]="addressAutoComplete.isOpen"
    class="e-input"
    trackable="Edit delivery/address"
    [class.invalid]="invalid"
    (focus)="focusAutoComplete(trigger)"
    placeholder="Start typing to get suggestions"
    formControlName="address"
    #autoCompleteInput
    #trigger="matAutocompleteTrigger"
    (keyup)="rememberInputText()"
    [matAutocomplete]="addressAutoComplete"
    matAutocompletePosition="below" />
  <mat-autocomplete
    #addressAutoComplete="matAutocomplete"
    class="slim search-autocomplete"
    (optionSelected)="onSelectOption($event)">
    <ng-container *ngIf="allowBack">
      <mat-option class="back-to-results" *ngIf="!autoCompleteSuggestionsAddressList.length">
        <div class="small-loading"></div>
      </mat-option>
      <mat-option
        class="back-to-results"
        trackable="Edit delivery/address/back-to-results"
        *ngIf="autoCompleteSuggestionsAddressList.length"
        [value]="inputBeforePostalCodeToSuggestions"
        (click)="backToPostalCode(trigger, $event)">
        <div class="title">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 8H1" stroke="#637EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 15L1 8L8 1" stroke="#637EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          BACK
        </div>
      </mat-option>
    </ng-container>

    <!--      Keep typing-->
    <ng-container *ngIf="autoCompleteInput.value.length > 0 && autoCompleteInput.value.length < 5 && !allowBack">
      <mat-option class="info-state-option keep-typing-state">
        <div class="title">
          <img [class.visible]="visible" src="../../../../assets/loading-circle-blue-animated.svg" alt="Keep typing" />
          Keep typing...
        </div>
      </mat-option>
    </ng-container>

    <!--        Addresses lists-->
    <ng-container
      *ngIf="
        !isPostalCodeSearch && autoCompleteInput.value.length >= 4 && autoCompleteSuggestionsAddressList.length > 0
      ">
      <ng-container *ngFor="let option of autoCompleteSuggestionsAddressList">
        <mat-option
          class="slim search-item"
          trackable="Edit delivery/address/address"
          (click)="selectSuggestedAddressName(trigger, option, $event)">
          <div class="search-item-info">
            <div class="option-name">{{ option.mainText }}</div>
            <div class="option-address">{{ option.secondaryText }}</div>
            <div class="show-more-arrow" *ngIf="option.kind && option.kind === 'LocationGroup'">
              <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 9L5 5L1 1"
                  stroke="#637EFF"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </mat-option>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="
        isPostalCodeSearch && autoCompleteInput.value.length >= 4 && autoCompleteSuggestionsAddressList.length > 0
      ">
      <ng-container *ngFor="let option of autoCompleteSuggestionsAddressList">
        <mat-option
          class="slim search-item"
          trackable="Edit delivery/address/address"
          (click)="selectSuggestedAddressName(trigger, option, $event)">
          <img src="../../../assets/search-terms/postcode.svg" alt="Postcode / Address" />
          <div class="search-item-info">
            <div class="option-name">{{ option.mainText }}</div>
            <div class="option-address">{{ option.secondaryText }}</div>
            <div class="show-more-arrow" *ngIf="option.kind && option.kind === 'LocationGroup'">
              <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 9L5 5L1 1"
                  stroke="#637EFF"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </mat-option>
      </ng-container>
    </ng-container>

    <!--        No results-->
    <ng-container>
      <ng-container *ngIf="autoCompleteInput.value.length >= 5 && autoCompleteSuggestionsAddressList.length === 0">
        <mat-option class="info-state-option empty-results-state" *ngIf="!waitingForResults">
          <div class="title">
            No results match <span class="no-match-term">'{{ autoCompleteInput.value }}'</span>
          </div>
          <div class="subtitle">Try a different search term</div>
        </mat-option>
        <mat-option class="keep-typing-state" *ngIf="waitingForResults && !allowBack">
          <div class="title">
            <img src="../../../../assets/loading-circle-blue-animated.svg" alt="Keep typing" /> Loading results...
          </div>
        </mat-option>
      </ng-container>
    </ng-container>
  </mat-autocomplete>
</ng-container>
